import React from 'react';
import { Grid, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export default function MyDatePicker({ control, ...others }) {
  return (
    <Grid item xs={12}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          {...others}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={false}
            />
          )}
        />
      </LocalizationProvider>
    </Grid>
  );
}
